<script setup lang="ts">
import ChatBotDialog from "@/components/navBar/aiassistant/ChatBotDialog.vue"
import {Dialog} from "quasar";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import Translator from "@/utils/common/Translator.ts";

function toggleDialog() {
  Dialog.create({
    component: ChatBotDialog,
    componentProps: {
      header: Translator.translateId('howCanIHelpYou')
    }
  })
}
</script>

<template>
  <div class="tw-flex tw-justify-center">
    <div
      class="tw-relative focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/75 hover:tw-cursor-pointer"
      @click="toggleDialog" :title="Translator.translateId('Nama AI Assistant')"
    >
      <NamaIcon default-icon="nm-ai" class="tw-size-6 compact:tw-size-[22px] ultra:tw-size-5"/>
    </div>
  </div>
</template>
